import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import ActionsLog from "../../../../components/common/ActionsLog";
import Notes from "../../../../components/common/Notes";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import Texts from "../../../../components/common/Texts";
import UpcomingActivities from "../../../../components/common/UpcomingActivities";
import { rentalApplicationsData } from "../../../../data/rentalapplications";
import Emails from "../../../../components/common/Emails";
import ApplicantSummary from "./components/ApplicantSummary";
import ApplicationFees from "./components/ApplicationFees";
import Contact from "./components/Contact";
import GroupedApplications from "./components/GroupedApplications";
import ResidentialHistory from "./components/ResidentialHistory";
import ScreeningActLog from "./components/ScreeningActLog";
import ScreeningReports from "./components/ScreeningReports";
import Vehicles from "../../../People/components/Vehicles";
import Pets from "../../../People/components/Pets";
import EmergencyContact from "./components/EmergencyContact";
import References from "./components/References";
import Dependents from "./components/Dependents";
import FinancialInformation from "./components/FinancialInformation";
import PersonalInformation from "./components/PersonalInformation";
import Income from "./components/Income";
import Questionss from "./components/Questions";
import ESignature from "./components/ESignature";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import { toast } from "react-hot-toast";

const RentalApplicationDetailsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Add Application", "1", "", "", ""),
    RightBarMethod("Group Applications", "2", "", "", ""),
    RightBarMethod("Remove From Group", "3", "", "", ""),
    RightBarMethod("View Guest Card", "4", "", "", ""),
    RightBarMethod("Generate Denial/Adverse Action Letter", "5", "", "", ""),
    RightBarMethod("Approve & Notify Applicat(s)", "6", "", "", ""),
    RightBarMethod("Email Group", "7", "", "", ""),
  ]),
  RightBarMethod(
    "HELP TOPICS",
    "t2",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod("Screening Criteria", "8", "", "", "/"),
      RightBarMethod("Screening Policies", "9", "", "", "/"),
      RightBarMethod("Income Verification", "10", "", "", "/"),
    ]
  ),
];

function RentalApplicationDetails() {
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [rentalAppDetails, setRentalAppDetails] = useState({});
  const [notes, setNotes] = useState([]);
  const { id } = useParams();

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const [rentalApplications, setRentalApplications] = useState(null);

  useEffect(() => {
    if (companyName) {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const rentalApplicationDocRef = doc(
        companyDocRef,
        "rentalApplications",
        id
      );

      // Retrieve the rental application document by its document ID
      getDoc(rentalApplicationDocRef)
        .then((docSnapshot) => {
          if (docSnapshot.exists()) {
            // Document exists; you can access its data
            const data = docSnapshot.data();
            console.log("Rental Application Data:", data);
            setRentalApplications(data)
          } else {
            console.log("Rental Application not found");
          }
        })
        .catch((error) => {
          console.error("Error fetching rental application:", error);
        });
    }
  }, [companyName]);

  useEffect(() => {
    const newObject = rentalApplicationsData[0].userRentalAppData.find(
      (item) => {
        return item.id === Number(id);
      }
    );
    setRentalAppDetails(newObject);
    console.log(newObject);
  }, []);

  return (
    <>
      <div className="rental-application-details">
        <PageHeading heading="Rental Application" />
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Contact
              data={rentalAppDetails?.contact ? rentalAppDetails.contact : null}
            />
          </Col>
          <Col span={24}>
            <GroupedApplications />
          </Col>
          <Col span={24}>
            <ApplicantSummary
              data={
                rentalAppDetails?.applicantSummary
                  ? rentalAppDetails.applicantSummary
                  : null
              }
            />
          </Col>
          <Col span={24}>
            <ScreeningReports
              data={
                rentalAppDetails?.screeningReports
                  ? rentalAppDetails.screeningReports
                  : null
              }
            />
          </Col>
          <Col span={24}>
            <ScreeningActLog />
          </Col>
          <Col span={24}>
            <ApplicationFees />
          </Col>
          <Col span={24}>
            <ResidentialHistory />
          </Col>
          <Col span={24}>
            <Income />
          </Col>
          <Col span={24}>
            <PersonalInformation />
          </Col>
          <Col span={24}>
            <FinancialInformation />
          </Col>
          <Col span={24}>
            <Dependents />
          </Col>
          <Col span={24}>
            <Pets />
          </Col>
          <Col span={24}>
            <References />
          </Col>
          <Col span={24}>
            <Vehicles />
          </Col>
          <Col span={24}>
            <EmergencyContact />
          </Col>
          <Col span={24}>
            <Questionss />
          </Col>
          <Col span={24}>
            <ESignature />
          </Col>
          <Col span={24}>
            <UpcomingActivities />
          </Col>
          <Col span={24}>
            {companyName ? (
              <Notes
                notesForCollection="rentalApplications"
                notesForCollectionId={id}
                companyName={companyName}
                notes={notes}
                setNotes={setNotes}
              />
            ) : null}
          </Col>
          <Col span={24}>
            {companyName ? (
              <AttachmentsUpload
                id={id}
                data={rentalApplications?.attachments}
                companyName={companyName}
                collection="rentalApplications"
              />
            ) : null}
          </Col>
          <Col span={24}>
            <Texts />
          </Col>
          <Col span={24}>
            <Emails />
          </Col>
          <Col span={24}>
            <ActionsLog />
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={RentalApplicationDetailsRightBar} />
      </div>
    </>
  );
}

export default RentalApplicationDetails;
